import React from "react";
import { useLocation } from "react-router-dom";
import { Result, Typography } from "antd";
import { BackBtn, RefreshBtn } from "../index";

const { Paragraph, Text } = Typography;

export const ErrorPage = () => {
    let location = useLocation();

    return (
        <Result status="error" title="Oops!" subTitle="Sorry, an unexpected error has occurred." extra={[<BackBtn type="primary" key="back" />, <RefreshBtn key="refresh" />]}>
            <div className="desc">
                <Paragraph>
                    <Text
                        strong
                        style={{
                            fontSize: 16,
                        }}>
                        The page you tried to open has the following error:
                    </Text>
                </Paragraph>
                <Paragraph copyable>No match for <code>{location.pathname}</code></Paragraph>
            </div>
        </Result>
    );
};
